import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0905Component } from './kymw0905.component';

/**
 * 商品企画栄養成分情報メンテナンス画面 モジュール設定クラス
 *
 * @export SampleWindowModule
 * @class SampleWindowModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppCommonsModule,
    PlessSharedModule,
    WjNavModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [
    KYMW0905Component,
  ],
  providers: [
  ],
})
export class KYMW0905Module { }
